import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var dropdownItemDangerousVariants = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_mlx0e80',variantClassNames:{danger:{true:'fx_2d2fb1e5_mlx0e81',false:'fx_2d2fb1e5_mlx0e82'}},defaultVariants:{danger:false},compoundVariants:[]});

export { dropdownItemDangerousVariants };
//# sourceMappingURL=item.vanilla.mjs.map
